import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  ssoButonLogin: {
    border: '1px solid #dadce0',
    borderRadius: '5px',
  },
}))

export default styles
